import { useEffect, useState } from 'react';

/** The value, but only after it has stopped changing for `ms`: keeps a search from firing on every key. */
export function useDebounced<T>(value: T, ms = 200): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
